import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

const mediaQuery = [{ screen: '(max-width: 767px)', width: '80vw' }]

export default function LianaMobile({ height }: { height?: number }): React.ReactElement {
  const { t } = useTranslation(['drill'])

  return (
    <div className="absolute z-0 -top-12 left-1/2 transform -translate-x-1/2 overflow-y-hidden" style={{ height }}>
      <ResponsiveImage
        alt={t('drill:imageAlt.topicBeanStalkMobile')}
        fit="inside"
        height={height ?? 800}
        imageClassName="max-w-none w-[330px]"
        loading="eager"
        mediaQuery={mediaQuery}
        srcKey="math-drills/topic-beanstalk-mobile.png"
        width={height ? (330 * height) / 3200 : 82}
      />
    </div>
  )
}
